<template>
  <div class="post-view" v-if="currentBlog">
    <div class="container">
      <div class="quillWrapper">
        <h2>{{ this.currentBlog[0].blogTitle }}</h2>
        <h4>
          Posted on: {{ new Date(this.currentBlog[0].blogDate).toLocaleString("en-us", { dateStyle: "long" }) }}
          &nbsp;|&nbsp;
          Site for: {{ this.currentBlog[0].blogSite }}
        </h4>
        <!--- <img :src="this.currentBlog[0].blogCoverPhoto" alt="" /> --->
        <div class="post-desc">{{ this.currentBlog[0].blogDesc }}</div>
        <YoutubeEmbed :youtubeId="this.currentBlog[0].youtubeID" />
        <div class="post-content ql-editor" v-html="this.currentBlog[0].blogHTML"></div>
      </div>
    </div>
  </div>
</template>

<script>
import YoutubeEmbed from '../components/YoutubeEmbed.vue';

export default {
  name: "ViewBlog",
  components: { YoutubeEmbed },
  data() {
    return {
      currentBlog: null,
    };
  },
  async mounted() {
    this.currentBlog = await this.$store.state.blogPosts.filter((post) => {
      return post.blogID === this.$route.params.blogid;
    });
  },
};
</script>

<style lang="scss">
.post-view {
  h4 {
    font-weight: 400;
    font-size: 14px;
    margin-bottom: 24px;
  }
  .post-desc {
    margin-bottom: 24px;
  }
}
</style>